<template>
    <div class="key-engagement-metrics" id="key-stats">
      <h3>Key Engagement Metrics</h3>
      <ul>
        <li v-for="(metric, index) in metrics" :key="index">
          <div class="metric-bar" :style="{ backgroundColor: metric.color }"></div>
          <div class="metric-content">
            <span class="label">{{ metric.label }}</span>
            <span class="value">{{ metric.value }}</span>
          </div>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'KeyEngagementMetrics',
    props: {
      metrics: Array,
    },
  };
  </script>
  
  <style scoped>
  .key-engagement-metrics {
    padding: 20px 0;
    text-align: left;
  }
  
  h3 {
    font-size: 42px;
    margin-bottom: 20px;
    text-align: left;
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
  
  li {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  
  .metric-bar {
    width: 10px;
    height: 40px;
    margin-right: 15px;
    border-radius: 5px;
  }
  
  .metric-content {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  
  .label {
    font-size: 16px;
    color: #666;
  }
  
  .value {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

   @media (max-width: 768px) {
    .label {
      font-size: 14px;
      color: #666;
    }
    
    .value {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
  
    h3 {
      font-size: 32px;
    }
  }
  </style>
